import React from "react";
import "./LogIn.scss";

function LogIn({ screenWidth }) {
  return (
    <div className={ screenWidth === "desktop" ? "logIn logIn-desktop" : "logIn logIn-mobile"}>
      <a className="logIn__subscribe"  href="https://www.cnn.com/subscription?source=sub_web_footersubnav-button&redirect=https%3A%2F%2Fwww.cnn.com%2F" 
      aria-label="Subscribe">Subscribe</a>
    <a
      className={
        screenWidth === "desktop" ? "logIn__logIn logIn__logIn-desktop" : "logIn__logIn logIn__logIn-mobile"
      }
      href="https://www.cnn.com/account/log-in"
      aria-label="Log In"
    >
     Sign In
    </a>
    </div>
  );
}

export default LogIn;
